module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "olst-field-modal"
  }, [_c('div', {
    staticClass: "modal-parent",
    attrs: {
      "id": _vm.name + '-modal'
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade-mask"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisplayed),
      expression: "isDisplayed"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "slide-modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisplayed),
      expression: "isDisplayed"
    }],
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return (function () {})($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  })]), _c('div', {
    staticClass: "modal-content clearfix"
  }, [_vm._t("default")], 2)])])], 1)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5be9c974!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@oliverstore/core-rendering-engine/src/views/components/mixins/GalleryModal.vue
// module id = 354
// module chunks = 1